import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import CircularProgress from 'material-ui/CircularProgress'
import moment from 'moment'
import Header from '../../components/Header/Header'
import EntityTable from '../../components/EntityTable/EntityTable'
import { getDashboard, getDeveloperDashboard } from '../../actions/dashboard'
import { getCities } from '../../actions/search'
import Constants from '../../utils/CommonConstants'

if (process.env.WEBPACK) {
  require('./EntityList.css')
}

const mapStateToProps = state => ({
  data: state.data,
  filters: state.filters,
  citiesIdNameMap: state.citiesIdNameMap,
  caseStatusMap: state.caseStatusMap,
  userInfo: state.userInfo
})

const mapDispatchToProps = dispatch => {
  return {
    getDashboard: bindActionCreators(getDashboard, dispatch),
    getDeveloperDashboard: bindActionCreators(getDeveloperDashboard, dispatch),
    getCities: bindActionCreators(getCities, dispatch),
    dispatch
  }
}

class EntityList extends Component {
  constructor(props) {
    super(props)
    this.state = {
      citiesIdNameMap: props.citiesIdNameMap || {},
      start: 0,
      isFetching: true,
      totalCount: 0,
      dataArr: [],
      startDate: null,
      endDate: null
    }
    let { keyName, dashboardType } = props.params
    let isKeyTypeBroker =
        Constants.dashboardEntityKeys.brokerEntities.includes(keyName),
      isKeyTypePayment =
        !isKeyTypeBroker &&
        Constants.dashboardEntityKeys[dashboardType].paymentEntities.includes(
          keyName
        ),
      isKeyTypeTermsheet =
        !isKeyTypeBroker &&
        Constants.dashboardEntityKeys[dashboardType].termsheetEntities.includes(
          keyName
        ),
      isKeyTypeRefund =
        !isKeyTypeBroker &&
        Constants.dashboardEntityKeys[dashboardType].refundEntities.includes(
          keyName
        )
    let caseSubTypeId
    switch (true) {
      case isKeyTypeBroker:
        caseSubTypeId = Constants.CaseSubTypeMap.BROKER_ORDER
        this.state.fields = Constants.entityTableFields.BROKER_ORDER
        break
      case isKeyTypePayment:
        caseSubTypeId = Constants.CaseSubTypeMap[dashboardType].PAYMENTS
        this.state.fields = Constants.entityTableFields.PAYMENTS
        break
      case isKeyTypeTermsheet:
        caseSubTypeId = Constants.CaseSubTypeMap[dashboardType].TERMSHEET
        this.state.fields = Constants.entityTableFields.TERMSHEET
        break
      case isKeyTypeRefund:
        caseSubTypeId = Constants.CaseSubTypeMap[dashboardType].REFUND
        this.state.fields = Constants.entityTableFields.REFUND
        break
    }
    this.caseSubTypeId = caseSubTypeId
  }

  processResultSet(results = [], citiesIdNameMap = {}) {
    const { caseStatusMap } = this.props
    return results.map(item => {
      item.rcmOrder.status = caseStatusMap[item.rcmOrder.statusId]
      item.rcmOrder.cityName = citiesIdNameMap[item.rcmOrder.cityId]
      item.rcmOrder.createdAtDate = moment(item.rcmOrder.createdAt).format(
        Constants.DATE_FORMAT
      )
      return item
    })
  }

  componentWillReceiveProps(nextProps) {
    const {
      dispatch,
      userInfo,
      getDeveloperDashboard,
      getDashboard,
      citiesIdNameMap
    } = this.props
    //  following block of code is for the case when userInfo is received
    //  after the API call, in this case the same result gets appneded twice
    if (nextProps.userInfo && !this.props.userInfo) {
      return
    }

    const { keyName, dashboardType } = this.props.params
    if (this.props.filters !== nextProps.filters) {
      dashboardType === 'dashboard'
        ? getDashboard(userInfo.id, null, [keyName])
        : getDeveloperDashboard(dashboardType, userInfo.id, null, [keyName])
    }

    let dataArr = this.state.dataArr || []
    let start = this.state.start || 0
    if (
      nextProps.data &&
      nextProps.data.results &&
      nextProps.data !== this.props.data
    ) {
      const resultSet = this.processResultSet(
        nextProps.data.results,
        citiesIdNameMap
      )
      if (this.state.start > 0) {
        dataArr = dataArr.concat(resultSet)
      } else {
        dataArr = resultSet
      }
      start = dataArr.length
    }

    if (citiesIdNameMap !== nextProps.citiesIdNameMap) {
      dataArr = this.processResultSet(dataArr, nextProps.citiesIdNameMap)
    }
    const dataList = {
      start,
      isFetching: false,
      totalCount: nextProps.data && nextProps.data.totalCount,
      dataArr
    }

    this.setState(dataList)
  }

  loadMore = () => {
    const { dispatch, userInfo, getDeveloperDashboard, getDashboard } =
      this.props
    const { keyName, dashboardType } = this.props.params
    let { startDate, endDate } = this.props.location.query
    startDate = new Date(parseInt(startDate))
    endDate = new Date(parseInt(endDate))
    const id = userInfo ? userInfo.id : null
    const start = this.state.start || 0
    this.setState({
      isFetching: true
    })
    dashboardType === 'dashboard'
      ? getDashboard(
          id,
          { paging: { start, rows: Constants.pageSize }, startDate, endDate },
          [keyName]
        )
      : getDeveloperDashboard(
          dashboardType,
          id,
          { paging: { start, rows: Constants.pageSize }, startDate, endDate },
          [keyName]
        )
  }

  refreshTable = () => {
    this.setState(
      {
        start: 0
      },
      this.loadMore
    )
  }

  componentWillMount() {
    const { citiesIdNameMap, getCities } = this.props
    if (!(citiesIdNameMap && Object.keys(citiesIdNameMap).length)) {
      getCities()
    }
    this.loadMore()
  }

  showMassAssign = keyName => {
    const { userInfo: { roles = [] } = {} } = this.props
    const {
      autoAssignKey,
      roles: { rcmDataAssignment }
    } = Constants
    if (roles.includes(rcmDataAssignment) && keyName === autoAssignKey) {
      return true
    }
    return !!(Constants.noMassAssignKeys.indexOf(keyName) === -1)
  }

  render() {
    const dashboardEntities = Constants.dashboardEntities
    const { userInfo } = this.props
    const { keyName } = this.props.params
    const title = (
      <div>
        Showing results for <strong>{dashboardEntities[keyName].name}</strong>
      </div>
    )
    const dataArr = this.state.dataArr
    if ((this.state.isFetching && dataArr.length === 0) || !userInfo) {
      return (
        <div>
          <Header {...this.props} />
          <div style={{ textAlign: 'center', marginTop: '30px' }}>
            <CircularProgress thickness={5} />
          </div>
        </div>
      )
    }
    if (dataArr === null || dataArr.length === 0) {
      return (
        <div>
          <Header {...this.props} />
          <div style={{ textAlign: 'center', marginTop: '30px' }}>
            Nothing to show here.
          </div>
        </div>
      )
    }
    const { fields } = this.state
    const massAssignStatus = this.showMassAssign(keyName)
    return (
      <div>
        <Header {...this.props} />
        <div className='entity-list'>
          <EntityTable
            title={title}
            fields={fields}
            dataArr={dataArr}
            loadMore={this.loadMore}
            location={this.props.location}
            totalCount={this.state.totalCount}
            isFetching={this.state.isFetching}
            keyName={keyName}
            refreshTable={this.refreshTable}
            caseSubTypeId={this.caseSubTypeId}
            showMassAssign={massAssignStatus}
          />
        </div>
      </div>
    )
  }
}

EntityList.propTypes = {
  dispatch: PropTypes.func.isRequired,
  location: PropTypes.object,
  userInfo: PropTypes.object,
  filters: PropTypes.object,
  params: PropTypes.object
}

export default connect(mapStateToProps, mapDispatchToProps)(EntityList)



/** WEBPACK FOOTER **
 ** ./src/containers/EntityList/EntityList.js
 **/